<template>
  <div class="container-fluid">
    <h2>System-Datensicherung</h2>
    <div class="toolbar mt-3">
      <button @click="saveConfig" id="config" class="btn btn-secondary">Konfiguration</button>
      <b-tooltip bottom target="config" triggers="hover">
        Konfigurationsdatenbank (inklusive Bestelldaten)
      </b-tooltip>
      <button @click="saveData" id="data" class="ml-3 mr-3 btn btn-secondary">Stammdaten</button>
      <b-tooltip target="data" triggers="hover">
        Stammdaten-Datenbank
      </b-tooltip>
      <button @click="saveTables" id="tables" class="mr-3 btn btn-secondary">Datentabellen</button>
      <b-tooltip target="data" triggers="hover">
        Extra Tabellen-Datenbank
      </b-tooltip>
      <button @click="startBackup" id="save" class="btn btn-primary">Archivierung</button>
      <b-tooltip target="save" triggers="hover">
        Startet den Backup Job
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'

export default {
  name: 'DataBackupView',
  methods: {
    saveData: function() {
      console.log('data');
      window.open(config.baseUrl + 'rest/backup/create?type=data');
    },
    saveTables: function() {
      console.log('backup tables');
      window.open(config.baseUrl + 'rest/backup/create?type=tables');
    },
    saveConfig: function() {
      console.log('config');
      window.open(config.baseUrl + 'rest/backup/create?type=config');
    },
    startBackup: function() {
      console.log('backup');
      config.get(this,config.baseUrl + 'rest/jobs/control?action=backup&target=none','Backup starten',function() {
          this.$bvToast.toast('Archivierung gestartet.',{title:'Backup-Job',variant:"success"});
      });
    }
  }
}
</script>
